import * as React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Text from "components/common/Text";
import Box from "components/common/Box";
import { useTheme } from "@mui/material/styles";
import SwipeableViews from "react-swipeable-views";
import { styled } from "@mui/styles";
import { makeStyles } from "@mui/styles";
import { CircularProgress } from "@mui/material";
import CheckinCustomerBasicDetail from "./CheckinCustomerBasicDetail";
import CustomerVechileTabs from "./CustomerVechileTabs";
import CustomerSearchHistoryTabs from "./CustomerSearchHistoryTabs";
import CustomerNavigationTabs from "./CustomerNavigationTabs";
import CustomerChargingHistoryTabs from "./CustomerChargingHistoryTabs";
import CheckInTablebycustomer from "./CustomerCheckInTabs";
import Grid from "components/common/Grid";
import Paper from "components/common/Paper";

const MTabs = styled(Tabs)({
  borderBottom: "1px solid #e8e8e8",
  "& .MuiTabs-indicator": {
    backgroundColor: "#19AA69",
  },
  "& .MuiTabs-flexContainer": {
    flexWrap: "wrap",
  },
  "@media (max-width:768px)": {
    width: "100%",
    marginL: "auto",
    "& .MuiTabs-indicator": {
      display: "none",
    },
  },
});

const MTab = styled((props) => <Tab disableRipple {...props} />)(
  ({ theme }) => ({
    textTransform: "none",
    width: "15%",
    "@media (max-width:768px)": {
      width: "100vw",
      margin: "auto",
    },

    marginRight: theme.spacing(1),
    color: "rgba(0, 0, 0, 0.85)",

    "&.Mui-selected": {
      color: "#19AA69",
    },
    "&.Mui-focusVisible": {
      backgroundColor: "#d1eaff",
    },
  })
);


function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tabpanel-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Text>{children}</Text>
        </Box>
      )}
    </Box>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tabpanel-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

export default function CheckInCustomerDetails({
  chekinNavigationData,
  dropdownData,
  searchhistorydata,
  customerDetails,
  isLoading,
  checkincustomertabledata,
  vehiclesdata,
  drawerOpen,
  handlecheckinsubmit,
  toggleDrawer,
  visit_id,
  opendr,
  chargingHistory
}) {
  const classes = useStyles();

  const formattedVehicles = vehiclesdata?.vehicles?.map((vehicle) => {
    return {
      vehicleRegistrationNo: vehicle?.vehicle_registration_no,
      usage: vehicle?.usage,
      iAm: vehicle?.i_am,
      year: vehicle?.year,
      vehiclePurchaseDate: vehicle?.vehicle_purchase_date,
      manufacturerId: vehicle?.manufacturer?.id,
      manufacturerName: vehicle?.manufacturer?.name,
      vehicleModelId: vehicle?.vehicle_model?.id,
      vehicleModelName: vehicle?.vehicle_model?.name,
      vehicleTypeId: vehicle?.vehicle_type?.id,
      vehicleTypeName: vehicle?.vehicle_type?.name,
      vehicleVariantId: vehicle?.vehicle_variant?.id,
      vehicleVariantName: vehicle?.vehicle_variant?.name,
    };
  });
  const theme = useTheme();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const handleChangeIndex = (index) => {
    setValue(index);
  };

  return (
    <>
     <Grid container>
      <Grid item xs={12} lg={12}>
        
        <Paper className={classes.checkInCustomerDetail_Container_page} sx={{  }} >
      {isLoading ? (
        <Box
        className={classes.checkInCustomerDetail_CircularProgress}
        >
          <CircularProgress />
        </Box>
      ) : (
        <Box
        className={classes.checkInCustomerDetail_box}  >
          <CheckinCustomerBasicDetail data={customerDetails} />
          <Text
          className={classes.checkInCustomerDetail_heading}>
            Activity logs
          </Text>
          <Box className={classes.checkInCustomerDetail_tab_container} >
            <MTabs
              value={value}
              onChange={handleChange}
              textColor="inherit"
              indicatorColor="inherit"
              aria-label="secondary Tabs example"
            >
              <MTab
                className={classes.checkInCustomerDetail_tab}
                label="Check In"
                {...a11yProps(0)}
              />
              <MTab
                className={classes.checkInCustomerDetail_tab}
                label="Vehicles"
                {...a11yProps(1)}
              />
              <MTab
                className={classes.checkInCustomerDetail_tab}
                label="Search history"
                {...a11yProps(2)}
              />
              <MTab
                className={classes.checkInCustomerDetail_tab}
                label="Navigation"
                {...a11yProps(3)}
              />
              <MTab
                className={classes.checkInCustomerDetail_tab}
                label="Charging history"
                {...a11yProps(4)}
              />
            </MTabs>
          </Box>
          <SwipeableViews
            axis={theme.direction === "rtl" ? "x-reverse" : "x"}
            index={value}
            onChangeIndex={handleChangeIndex}
          >
            <TabPanel value={value} index={0} dir={theme.direction}>
              {/* <CustomerCheckInTabs
                data={checkincustomertabledata?.visitDetails}
              /> */}

              <CheckInTablebycustomer
                data={checkincustomertabledata?.visitDetails}
                drawerOpen={drawerOpen}
                opentoggle={opendr}
                toggleDrawer={toggleDrawer}
                visit_id={visit_id}
                dropdownData={dropdownData}
                handlecheckinsubmit={handlecheckinsubmit}
              />
            </TabPanel>
            <TabPanel value={value} index={1} dir={theme.direction}>
              <CustomerVechileTabs data={formattedVehicles} />
            </TabPanel>
            <TabPanel value={value} index={2} dir={theme.direction}>
              <CustomerSearchHistoryTabs
                data={searchhistorydata?.searchHistory}
              />
            </TabPanel>
            <TabPanel value={value} index={3} dir={theme.direction}>
              <CustomerNavigationTabs
                data={chekinNavigationData?.navigationHistory}
              />
            </TabPanel>
            <TabPanel value={value} index={4} dir={theme.direction}>
            <CustomerChargingHistoryTabs data={chargingHistory}/>
            </TabPanel>
          </SwipeableViews>
        </Box>
      )}
       </Paper>
      </Grid>
    </Grid>
    </>
  );
}


const useStyles = makeStyles((theme) => ({
  checkInCustomerDetail_Container_page:{
    padding: '1rem', 
    marginTop: '1rem', 
    marginLeft: "5px", 
    width: "76vw"
  },
  checkInCustomerDetail_CircularProgress:{
    display: "flex", 
    justifyContent: "center", 
    marginTop: "300px" 
  },
  checkInCustomerDetail_box:{
    backgroundColor: "white",
    overflow: "hidden",
    padding: "20px",
  },
  checkInCustomerDetail_heading:{
    color: "#545454",
    fontSize: "16px",
    fontWeight: "700",
    borderBottom: "1px solid #EAEAEA",
    paddingBottom: "5px",
  },
  checkInCustomerDetail_tab_container:{
  width: "100%", 
  borderBottom: 0, 
  borderColor: "divider"
  },
  checkInCustomerDetail_tab:{
    fontSize: "16px",
     color: "#707070" 
  }
}));
